import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { showSuccessSnackbar, showErrorDialog } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { UkFitAndProperDeclaration, UkFitAndProperDeclarationToAdd } from './uk-fit-and-proper-declaration.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UkFitAndProperDeclarationService {
  private apiEndpoint = `${environment.apiEndpoint}/api/uk/employee-fit-and-proper-declarations`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public apiErrorDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  getMine$(): Observable<UkFitAndProperDeclaration | null> {
    return this.http.get<UkFitAndProperDeclaration>(`${this.apiEndpoint}/me`).pipe(catchError(() => of(null)));
  }

  getOne$(email: string): Observable<UkFitAndProperDeclaration | null> {
    return this.http.get<UkFitAndProperDeclaration>(`${this.apiEndpoint}/${email}`).pipe(catchError(() => of(null)));
  }

  acknowledge$(value: UkFitAndProperDeclarationToAdd): Observable<void> {
    return this.http.post(this.apiEndpoint, value).pipe(
      map(() => showSuccessSnackbar(this.snackBar, 'Your declaration was successfully recorded')),
      catchError((error: any) => {
        this.logger.error(error);
        showErrorDialog(this.apiErrorDialog, error);
        return throwError(() => new Error(error));
      })
    );
  }

  public markAsComplianceChecked$(id: number, checkedBy: string, checked: Date): Observable<void> {
    return this.http
      .patch(`${this.apiEndpoint}/${id}/mark-compliance-checked`, {
        checkedBy,
        checked
      })
      .pipe(
        map(() => showSuccessSnackbar(this.snackBar, 'Declaration marked as checked successfully')),
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.apiErrorDialog, error);
          return throwError(() => new Error(error));
        })
      );
  }
}
